var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "url(#pattern0_106_1286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_106_1286",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_106_1286",
    transform: "scale(0.04 0.0384615)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_106_1286",
    width: 25,
    height: 26,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAMAAAB1owf/AAAAAXNSR0IB2cksfwAAAWJQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+cz50QAAAHZ0Uk5TAFzC0tHU1dO2P1D//vf49CuvzRgNDirqfbkyJ0TuiLeGury73eYEKftmaZ+Jd5HIqT7EglGZq44FFZwIzyADv5RJs1YC266kc6xPcbiK81lnbY21TPklrYEdBwmj9oMUpjeQchPAQdjtHJ3XU95qNZ7phx+M9WDrMrMAAAFwSURBVHicY2RgBAIGIICSf0EkAwvjd0YusABYBsj6/w/KY2FkFPwFYbJDtDIyfoHweRklP0FYv0WgZr6D8IUZ5d8wYAWiUJkfYhwQ+xj//eB+jiQjxXgLoVqd8TFChlmAG+ZEhv9MD/8jmYbbHpA+ES6gw+9gyqg+ewWiDBlvoslonGUwAWr5dd7ix20UGdULlq9egBj6b0QZzyPJsOgxMp6BmGJ6wPEURAYcOub7nE9AbWbk0mM8Bg4dt6Og4HvhfgTmKNsdnodAQoxeB4GUw1af/TAZp80gVc4nGBn8Pxxh8dyg/QAm47Y+aCNDwL3zoEBxYWDYE7IdKuHFuArEB1oIUxq+BUL7roA5BUJFAn25ARiQQYyL4m8dR5ZRsnuyJ3G7F+OOpymnOU4iyRje/h/FOAtk5X+VJbGM0xEyWQuBRALjFF2HeUBG8iSETP5juafbZP/fBCaxtCO2jL1I9jAwaP736WFgUAyZ8h0qAABW8Gzth2V7pwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.fd4eca13e1774e737c9699d573804411.svg";
export { ForwardRef as ReactComponent };